import { useAuth } from '../context/authContext';
import { QuizRegister } from '../components/QuizRegister';
import { QuizNotRegister } from '../components/QuizNotRegister';

const Quiz = () => {  
    const { isAuthenticated } = useAuth();
    
    return (
        <>
        {isAuthenticated? <QuizRegister/> : <QuizNotRegister/>}
        </>
    )
}

export default Quiz;
